import { useTranslation } from 'react-i18next';

import 'components/desktop/_general/SeasonalityBar/SeasonalityBar.scss';
import { seasonsHistogram } from 'types/Recipe/Recipe';

interface HoveredColState {
	hoveredRange: number[];
	color: string;
}

interface IProps {
	seasonsHistogram: seasonsHistogram;
	currentMonth: {
		key: number;
		name: string;
	};
	setHoveredCol: React.Dispatch<React.SetStateAction<HoveredColState>>;
}

const intervalsEdgesPercentage = {
	medium: 60,
	high: 80,
};

interface Interval {
	label: string;
	range: number;
	rangeStart: number;
	rangeEnd: number;
}

function shortenToIntervals(months: number[]): Interval[] {
	const intervals: Interval[] = [];
	let currentLabel = null;
	let currentCount = 0;
	let rangeStart = 0;

	const getLabel = (value: number) => {
		if (value <= intervalsEdgesPercentage.medium) return 'Low';
		if (value > intervalsEdgesPercentage.medium && value <= intervalsEdgesPercentage.high)
			return 'Medium';
		if (value > intervalsEdgesPercentage.high) return 'High';
		return null;
	};

	for (let i = 0; i < months.length; i++) {
		const label = getLabel(months[i]);

		if (label === currentLabel) {
			currentCount++;
		} else {
			if (currentLabel !== null) {
				intervals.push({
					label: currentLabel,
					range: currentCount,
					rangeStart,
					rangeEnd: rangeStart + currentCount,
				});
				rangeStart += currentCount;
			}
			currentLabel = label;
			currentCount = 1;
		}
	}

	if (currentLabel !== null) {
		intervals.push({
			label: currentLabel,
			range: currentCount,
			rangeStart,
			rangeEnd: rangeStart + currentCount,
		});
	}

	return intervals;
}

const colors = {
	low: '#ffcaa7',
	medium: '#fde79d',
	high: '#97dbbd',
};

const SeasonsHistogramLarge = (props: IProps) => {
	const { t } = useTranslation();

	const histogramValues = Array.from({ length: 12 }, (_, i) => {
		const value = props.seasonsHistogram[i];
		return Math.round(Math.ceil(value * 100));
	});

	const handleMouseEnter = async (indexes: { hoveredRange: number[]; color: string }) => {
		props.setHoveredCol(indexes);
	};
	const handleMouseLeave = () => {
		props.setHoveredCol({ hoveredRange: [12, 12], color: '' });
	};

	const resultIntervals: Interval[] = shortenToIntervals(histogramValues);

	if (props.seasonsHistogram) {
		return (
			<tr style={{ userSelect: 'none' }}>
				<td className="table-primary">{t('seasonality:OVERALL_SEASONAL_AVAILABILITY')}</td>
				{resultIntervals.map((interval, i) => {
					return (
						<td
							key={i}
							colSpan={interval.range}
							onMouseEnter={() =>
								handleMouseEnter({
									hoveredRange: [interval.rangeStart, interval.rangeEnd - 1],
									color: interval.label.includes('Low')
										? colors.low
										: interval.label.includes('Medium')
										? colors.medium
										: colors.high,
								})
							}
							onMouseLeave={handleMouseLeave}
							style={
								{
									textAlign: 'center',
									width: '5.5rem',
									'--bs-table-bg-type': 'initial',
									backgroundColor: interval.label.includes('Low')
										? colors.low
										: interval.label.includes('Medium')
										? colors.medium
										: interval.label.includes('High')
										? colors.high
										: '',
								} as React.CSSProperties
							}
						>
							{interval.label === 'Low'
								? t('seasonality:LOW')
								: interval.label === 'Medium'
								? t('seasonality:MEDIUM')
								: t('seasonality:HIGH')}
						</td>
					);
				})}
			</tr>
		);
	} else {
		return <></>;
	}
};

export default SeasonsHistogramLarge;
